import { render, staticRenderFns } from "./VideoFormAvatar.vue?vue&type=template&id=7b86a646&scoped=true&"
import script from "./VideoFormAvatar.vue?vue&type=script&lang=js&"
export * from "./VideoFormAvatar.vue?vue&type=script&lang=js&"
import style0 from "./VideoFormAvatar.vue?vue&type=style&index=0&id=7b86a646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86a646",
  null
  
)

export default component.exports